// extracted by mini-css-extract-plugin
module.exports = {"badge":"yandexLink_badge__y1b4y","yandexText":"yandexLink_yandexText__7dQ7A"};